angular.module('impactx.search').service('SearchFilter', [
    'dataGen',
    'AppConfiguration',
    'SearchFilterStorage',
    '$mdSidenav',
    '$redirect',
    '$location',
    '$q',
    '$rootScope',
    SearchFilter
]);

function SearchFilter(dataGen, AppConfiguration, SearchFilterStorage, $mdSidenav, $redirect, $location, $q, $rootScope) {
    var self = this;
    var searchFilter;
    var filters = {};
    var currentIdentifier = 'search';
    var NONE = 0, PRICE_ASCENDING = 1, PRICE_DESCENDING = 2, NAME_ASCENDING = 3, NAME_DESCENDING = 4;
    var nameSortOption = NONE;
    var priceSortOption = NONE;
    var config = {};
    var sidebarIdentifier = 'searchFilterSidebar';
    var sidebarAvailable = false;
    var sidebarIsOpen = false;
    var trns = {};
    self.searchInputClassification = {};
    self.levelOneClassifications = null;
    self.selectedFilter = {
        entries: [],
        amount: 0
    };

    function initialize() {
        var result = {};
        config.showProductFamilyFilter = AppConfiguration.get('showProductFamilyFilter');
        config.showProcurementGroupFilter = AppConfiguration.get('showProcurementGroupFilter');
        config.showGuidingClassificationFilter = AppConfiguration.get('showGuidingClassificationFilter') && AppConfiguration.get('hasGuidingClassification');
        config.showCountryFilter = AppConfiguration.get('showCountryFilter');

        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            searchFilter = freshFilter;
            searchFilter.forProductView = false;
            return searchFilter;
        }
        else {
            return dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                SearchFilterStorage.setFreshFilter(result.data);
                searchFilter = result.data;
                searchFilter.forProductView = false;
                return searchFilter;
            });
        }
    }

    function sortByName(notSetSelected) {
        priceSortOption = NONE;
        switch (nameSortOption) {
            case NONE:
                nameSortOption = NAME_ASCENDING;
                break;
            case NAME_ASCENDING:
                nameSortOption = NAME_DESCENDING;
                break;
            case NAME_DESCENDING:
                nameSortOption = NONE;
        }
        if (!notSetSelected) {
            setSelectedSort(nameSortOption);
        }
        return nameSortOption;
    }

    function sortByPrice(notSetSelected) {
        nameSortOption = NONE;
        switch (priceSortOption) {
            case NONE:
                priceSortOption = PRICE_ASCENDING;
                break;
            case PRICE_ASCENDING:
                priceSortOption = PRICE_DESCENDING;
                break;
            case PRICE_DESCENDING:
                priceSortOption = NONE;
        }
        if (!notSetSelected) {
            setSelectedSort(priceSortOption);
        }
        return priceSortOption;
    }

    function setSelectedSort(sortId) {
        searchFilter.sort.selected = getSelectedSort(sortId)
    }

    function getSelectedSort(sortId) {
        var selected = searchFilter.sort.entries[0];
        angular.forEach(searchFilter.sort.entries, function (entry) {
            if (entry.id == sortId) {
                selected = entry;
            }
        });
        return selected;
    }

    function resetSort() {
        nameSortOption = NONE;
        priceSortOption = NONE;
    }

    function sortByNameASC() {
        setSelectedSort(NAME_ASCENDING);
    }

    function setFacets(facets, guidedFacets) {
        searchFilter.facets = facets;
        searchFilter.guidedFacets = guidedFacets;
    }

    function setProductLabelGroups(productLabelGroups) {
        searchFilter.productLabelGroups = productLabelGroups;
    }

    function setEnergyLabelGroups(energyLabelGroups) {
        searchFilter.energyLabelGroups = energyLabelGroups;
    }

    function nextEClassLevel(selectedNode) {
        var prgId = impactX.isDefined(selectedNode, 'id') ? selectedNode.id : 0;
        return dataGen.getData({}, {prgId: prgId, filterIdentifier: currentIdentifier}, "/search/filter/eclass", null, true).then(function (data) {
            if (impactX.isDefined(data, "data")) {
                return data.data;
            }
        });
    }

    function getLevelOneGuidingClassification() {
        if (!self.levelOneClassifications) {
            return dataGen.getData({}, {filterIdentifier: currentIdentifier}, '/search/filter/eclass/levelone', null, true).then(function (data) {
                if (impactX.isDefined(data, 'data.subEntries')) {
                    self.levelOneClassifications = data.data.subEntries;
                    return self.levelOneClassifications;
                }
            });
        }
        else {
            return $q.resolve(self.levelOneClassifications);
        }
    }

    function setGuidingClassification(guidingClassification) {
        if (guidingClassification.id) {
            searchFilter.guidingClassification.selected = guidingClassification;
        }
        else {
            searchFilter.guidingClassification.selected = null;
        }
    }

    function getGuidingClassification() {
        return searchFilter.guidingClassification.selected;
    }

    function setSearchInputClassification(guidingClassification) {
        if (impactX.isDefined(guidingClassification, 'id') >= 0) {
            self.searchInputClassification = guidingClassification ? guidingClassification : {id: 0};
        }
        else {
            self.searchInputClassification = null;
        }
    }

    function setProductFamily(productFamily) {
        searchFilter.productFamily.selected = productFamily;
    }

    function setProductFamilies(productFamilies) {
        searchFilter.productFamily.entries = productFamilies;
    }

    function setProcurementGroup(procurementGroup) {
        searchFilter.procurementGroup.selected = procurementGroup;
    }

    function setProcurementGroups(procurementGroups) {
        searchFilter.procurementGroup.entries = procurementGroups;
    }

    function setCountries(countries) {
        if (config.showCountryFilter && searchFilter.country) {
            searchFilter.country.entries = countries;
        }
    }

    function getSearchInputClassification() {
        return impactX.isDefined(searchFilter, 'guidingClassification.selected');
    }

    function getFilters() {
        var sidenav = $mdSidenav(sidebarIdentifier, true);
        if (sidenav && sidenav.then) {
            sidenav.then(function () {
                sidebarAvailable = true;
                if (AppConfiguration.get('showFiltersOnLoad')) {
                    openSidebar();
                }
            });
        }

        if (searchFilter) {
            return searchFilter;
        }
        else {
            return initialize();
        }
    }

    function getAngularService() {
        if (ixUpgrade && typeof ixUpgrade.getAngularService === 'function') {
            return ixUpgrade.getAngularService("SearchFilterService");
        }
        return null;
    }

    function hasSidenavElement() {
        var el = document.getElementById("searchFilterSidebarRawId");
        return !!el;
    }

    function getSidenavOrAngularService() {
        var angularService = getAngularService();
        if (angularService && angularService.isActive()) {
            return angularService;
        }
        if (sidebarAvailable && hasSidenavElement()) {
            return $mdSidenav(sidebarIdentifier);
        }
        return null;
    }

    function isOpen() {
        var elem = getSidenavOrAngularService();
        return elem ? elem.isOpen() : false;
    }

    function openSidebar() {
        var elem = getSidenavOrAngularService();
        if (elem) {
            var result = elem.open();
            if (result && result.then) {
                result.then(function() {
                    if (!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                });
            }
        }
    }

    function closeSidebar() {
        var elem = getSidenavOrAngularService();
        if (elem) {
            var result = elem.close();
            if (result && result.then) {
                result.then(function() {
                    if (!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                });
            }
        }
    }

    function toggleFilterSidebar() {
        var elem = getSidenavOrAngularService();
        if (elem) {
            var result = elem.toggle();
            // $mdSidenav.toggle() returns a promise - trigger digest after it resolves
            if (result && result.then) {
                result.then(function() {
                    if (!$rootScope.$$phase) {
                        $rootScope.$apply();
                    }
                });
            }
        }
    }

    function notifyFilterChanged() {
        var angularService = getAngularService();
        if (angularService && typeof angularService.notifyFilterChanged === 'function') {
            angularService.notifyFilterChanged();
        }
    }

    /**
     * Sets translations on the shared trns object (in-place update to preserve reference).
     * Called from Angular side to pass server response translations.
     */
    function setTrns(translationsToSet) {
        if (translationsToSet) {
            angular.forEach(translationsToSet, function (value, key) {
                trns[key] = value;
            });
        }
    }

    /**
     * Checks if the filter is ready to be shown.
     * Used by Angular hybrid views where the AngularJS controller state might not be available.
     * Falls back to checking the Angular service.
     */
    function isFilterReady() {
        var angularService = getAngularService();
        if (angularService && typeof angularService.isFilterReady === 'function') {
            return angularService.isFilterReady();
        }
        // Fallback: if searchFilter exists and is initialized, we're ready
        return !!searchFilter;
    }

    function setSupplier(supplier) {
        searchFilter.supplier.selected = supplier;
    }

    function getSupplier() {
        return impactX.isDefined(searchFilter, 'supplier.selected');
    }

    function setManufacturer(manufacturer) {
        searchFilter.manufacturer.value = manufacturer ? manufacturer : '';
    }

    function setContractNo(contractNo) {
        searchFilter.contractNo.value = contractNo ? contractNo : '';
    }

    function setListFilterField(field, value) {
        searchFilter.listFilters[field].value = value ? value : '';
    }

    function setListFilterPopupField(field, selected) {
        searchFilter.listFilters[field].selected = selected;
    }

    function setListFilterDateField(field, selected) {
        searchFilter.listFilters[field].dateValue = selected.dateValue;
        searchFilter.listFilters[field].value = selected.value;
    }

    function setSupplierNo(supplierNo) {
        searchFilter.supplierNo.value = supplierNo ? supplierNo : '';
    }

    function setManufacturerNo(manufacturerNo) {
        searchFilter.manufacturerNo.value = manufacturerNo ? manufacturerNo : '';
    }

    function setEan(ean) {
        searchFilter.ean.value = ean ? ean : '';
    }

    function setCategory(category) {
        searchFilter.category.selected = category;
    }

    function setMinPrice(minPrice) {
        searchFilter.priceRange.minValue = minPrice;
    }

    function setMaxPrice(maxPrice) {
        searchFilter.priceRange.maxValue = maxPrice;
    }

    function setTenderId(tenderId) {
        if (tenderId && tenderId > 0) {
            searchFilter.tenderId = {value: tenderId};
        }
    }

    function setLotId(lotId) {
        if (lotId && lotId > 0) {
            searchFilter.lotId = {value: lotId};
        }
    }

    function setSupplierId(supplierId) {
        if (supplierId && supplierId > 0) {
            searchFilter.supplierId = {value: supplierId};
        }
    }

    function getConfig() {
        if (config.showGuidingClassificationFilter === undefined) {
            config.showProductFamilyFilter = AppConfiguration.get('showProductFamilyFilter');
            config.showProcurementGroupFilter = AppConfiguration.get('showProcurementGroupFilter');
            config.showGuidingClassificationFilter = AppConfiguration.get('showGuidingClassificationFilter') && AppConfiguration.get('hasGuidingClassification');
            config.showCountryFilter = AppConfiguration.get('showCountryFilter');
        }
        return config;
    }

    function toggleDrillDown(item) {
        deSelectLowerDrillDownsIfSet(item);
        var indexToRemove = -1;
        var drillDowns = searchFilter.drillDowns;
        angular.forEach(drillDowns, function (value, key) {
            if (value.pathHashString == item.pathHashString) {
                indexToRemove = key;
            }

        });
        if (indexToRemove >= 0) {
            drillDowns.splice(indexToRemove, 1)
        }
        else {
            drillDowns.push(item)
        }
    }


    function deSelectLowerDrillDownsIfSet(item) {
        if (item.level > 0 && exists(item)) {
            var indexToRemove = -1;
            var drillDowns = searchFilter.drillDowns;
            angular.forEach(drillDowns, function (value, key) {
                if (value.patId == item.patId && value.level > item.level) {
                    indexToRemove = key;
                }

            });
            if (indexToRemove >= 0) {
                drillDowns.splice(indexToRemove, 1);
                deSelectLowerDrillDownsIfSet(item);
            }
        }
    }

    function existsDrillDown(item) {
        var index = -1;
        angular.forEach(searchFilter.drillDowns, function (value, key) {
            if (value.pathHashString == item.pathHashString) {
                index = key;
            }

        });
        return index > -1;
    }

    function setFilters(searchFilterToSet) {
        searchFilter = searchFilterToSet;
    }

    function resetSearchInput() {
        if (searchFilter && searchFilter.searchInput) {
            searchFilter.searchInput.value = '';
        }
    }

    function resetSearch() {
        var freshFilter = SearchFilterStorage.getFreshFilter();
        if (freshFilter) {
            setFilters(freshFilter);
        }
    }

    function filterProductGroup(productGroup, searchFilter) {
        var storedSearchFilterObject = SearchFilterStorage.getVCatFilter(productGroup.vCatId);
        if (storedSearchFilterObject) {
            storedSearchFilterObject.productGroupSelected = true;
            $redirect.redirectTo(null, "/vcatalog/" + productGroup.vCatId + "/" + productGroup.id)
        }
        else {
            var freshFilter = SearchFilterStorage.getFreshFilter();
            if (freshFilter) {
                var filter = freshFilter;
                filter.vcatalogId = {value: productGroup.vCatId};
                filter.dialogFilter = "vcat_prg" + productGroup.id;
                filter.prgId = {value: productGroup.id};
                filter.productGroupSelected = true;
                SearchFilterStorage.setVCatFilter(productGroup.vCatId, filter);
                searchFilter.searchInput = filter.searchInput.value;
                setFilters(filter);
                $redirect.redirectTo(null, "/vcatalog/" + productGroup.vCatId + "/" + productGroup.id)
            }
            else {
                var result = {};
                var currentLocation = $location.path();
                dataGen.getData(result, {}, "/search/filter", null, true).then(function () {
                    SearchFilterStorage.setFreshFilter(result.data);
                    var filter = result.data;
                    filter.vcatalogId = {value: productGroup.vCatId};
                    filter.dialogFilter = "vcat_prg" + productGroup.id;
                    filter.prgId = {value: productGroup.id};
                    SearchFilterStorage.setVCatFilter(productGroup.vCatId, filter);
                    if ($location.path() === currentLocation) {
                        //only if we are still on the same page.
                        filter.productGroupSelected = true;
                        searchFilter.searchInput = filter.searchInput.value;
                        setFilters(filter);
                        $redirect.redirectTo(null, "/vcatalog/" + productGroup.vCatId + "/" + productGroup.id)
                    }
                });
            }
        }
    }

    $rootScope.$on('loginSuccess', resetAndGetLevelOneClassifications);
    $rootScope.$on('logoutSuccess', resetLevelOneClassifications);
    $rootScope.$on('$routeChangeSuccess', function () {
        sidebarAvailable = false;
    });

    function resetLevelOneClassifications() {
        self.levelOneClassifications = null;
    }

    function resetAndGetLevelOneClassifications() {
        resetLevelOneClassifications();
        if (AppConfiguration.get('showGuidingClassificationFilter') && AppConfiguration.get('hasGuidingClassification')) {
            getLevelOneGuidingClassification();
        }
    }

    function setFilterIdentifier(identifier) {
        if (!currentIdentifier) {
            currentIdentifier = 'search';
        }
        if (!identifier) {
            identifier = 'search';
        }

        filters[currentIdentifier] = searchFilter;
        currentIdentifier = identifier;
        searchFilter = filters[currentIdentifier];

        resetAndGetLevelOneClassifications();
    }

    function getFilterIdentifier() {
        return currentIdentifier;
    }

    function resetAllFilters() {
        searchFilter.facets = [];
        searchFilter.productLabelGroups = [];
        searchFilter.energyLabelGroups = [];
        searchFilter.productFamily.entries = [];
        searchFilter.procurementGroup.entries = [];
        if (config.showCountryFilter && searchFilter.country) {
            searchFilter.country.entries = [];
        }
    }

    return {
        initialize: initialize,
        sortByName: sortByName,
        sortByPrice: sortByPrice,
        getFilters: getFilters,
        setFacets: setFacets,
        setProductLabelGroups: setProductLabelGroups,
        setEnergyLabelGroups: setEnergyLabelGroups,
        toggleDrillDown: toggleDrillDown,
        existsDrillDown: existsDrillDown,
        nextEClassLevel: nextEClassLevel,
        setGuidingClassification: setGuidingClassification,
        setProductFamily: setProductFamily,
        setProcurementGroup: setProcurementGroup,
        getLevelOneGuidingClassification: getLevelOneGuidingClassification,
        setSearchInputClassification: setSearchInputClassification,
        getSearchInputClassification: getSearchInputClassification,
        isOpen: isOpen,
        openSidebar: openSidebar,
        closeSidebar: closeSidebar,
        toggleFilterSidebar: toggleFilterSidebar,
        setSupplier: setSupplier,
        getSupplier: getSupplier,
        setManufacturer: setManufacturer,
        setContractNo: setContractNo,
        setSupplierNo: setSupplierNo,
        setManufacturerNo: setManufacturerNo,
        setEan: setEan,
        setMinPrice: setMinPrice,
        setMaxPrice: setMaxPrice,
        getConfig: getConfig,
        getSelectedSort: getSelectedSort,
        resetSort: resetSort,
        setFilters: setFilters,
        setCategory: setCategory,
        resetSearchInput: resetSearchInput,
        selectedFilter: self.selectedFilter,
        resetSearch: resetSearch,
        filterProductGroup: filterProductGroup,
        setProcurementGroups: setProcurementGroups,
        setProductFamilies: setProductFamilies,
        setTenderId: setTenderId,
        setLotId: setLotId,
        setSupplierId: setSupplierId,
        setCountries: setCountries,
        getGuidingClassification: getGuidingClassification,
        setFilterIdentifier: setFilterIdentifier,
        getFilterIdentifier: getFilterIdentifier,
        sortByNameASC: sortByNameASC,
        setListFilterField: setListFilterField,
        setListFilterPopupField: setListFilterPopupField,
        setListFilterDateField: setListFilterDateField,
        resetAllFilters: resetAllFilters,
        notifyFilterChanged: notifyFilterChanged,
        isFilterReady: isFilterReady,
        trns: trns,
        setTrns: setTrns
    };
}
